import { MessageStackState } from '/@/app/components/MessageStack/MessageStackState';

//
// Global message stack for the app
//
export const messageStackState = new MessageStackState();
